import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss'],
})
export class BankDetailsComponent {
  url;
  id;
loader:boolean = false;
userObj:any=[];
firstName;
bankName;
branch;
accountNbr;
ifsc;
constructor(public service: ApiService,
  public router: Router,
  public handler: HandlerService,
  public auth: AuthService,
  public app: AppComponent
 ) { }

  ionViewWillEnter() {
    this.url = window.location.href;
    this.id = this.url.split('/').pop();
    this.service.getAddressById(this.id).subscribe(res => {
      this.userObj = res;
      if(this.userObj.bankDetails){
        this.firstName = this.userObj.bankDetails[0].accntHolderName;
        this.bankName = this.userObj.bankDetails[0].bankName;
        this.branch = this.userObj.bankDetails[0].branch;
        this.accountNbr = this.userObj.bankDetails[0].accNumb;
        this.ifsc = this.userObj.bankDetails[0].ifsc;
      }
    });
  }

  edit(){
    this.router.navigate(['editDetails/',this.id])
  }

}
